(function () {
  function initHeader(root) {
    if (!root || root.dataset.mcReady === 'true') return;
    root.dataset.mcReady = 'true';

    var overlay = root.querySelector('[data-mc-overlay]');
    var drawers = Array.prototype.slice.call(root.querySelectorAll('[data-mc-drawer]'));
    var openers = Array.prototype.slice.call(root.querySelectorAll('[data-mc-open]'));
    var activeTrigger = null;
    var focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      'summary',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    var searchForm = root.querySelector('.mc-search-form');
    if (searchForm && !searchForm.querySelector('input[name="options[prefix]"]')) {
      var prefixInput = document.createElement('input');
      prefixInput.type = 'hidden';
      prefixInput.name = 'options[prefix]';
      prefixInput.value = 'last';
      searchForm.appendChild(prefixInput);
    }

    drawers.forEach(function (drawer) {
      var name = drawer.getAttribute('data-mc-drawer');
      if (!drawer.id) drawer.id = root.id + '-' + name + '-drawer';
      drawer.setAttribute('aria-hidden', drawer.classList.contains('is-open') ? 'false' : 'true');
    });

    openers.forEach(function (button) {
      var name = button.getAttribute('data-mc-open');
      var drawer = root.querySelector('[data-mc-drawer="' + name + '"]');
      button.setAttribute('aria-expanded', 'false');
      if (drawer && drawer.id) button.setAttribute('aria-controls', drawer.id);
    });

    function getOpenDrawer() {
      return drawers.find(function (drawer) {
        return drawer.classList.contains('is-open');
      }) || null;
    }

    function getFocusable(drawer) {
      if (!drawer) return [];
      return Array.prototype.slice.call(drawer.querySelectorAll(focusableSelector)).filter(function (element) {
        return element.getClientRects().length > 0 && element.getAttribute('aria-hidden') !== 'true';
      });
    }

    function syncPageLock() {
      var hasOpenDrawer = drawers.some(function (drawer) {
        return drawer.classList.contains('is-open');
      });
      document.documentElement.style.overflow = hasOpenDrawer ? 'hidden' : '';
      if (overlay) overlay.classList.toggle('is-open', hasOpenDrawer);
    }

    function closeAll(options) {
      var settings = options || {};
      drawers.forEach(function (drawer) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
      });
      openers.forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
      syncPageLock();

      if (settings.restoreFocus !== false && activeTrigger && document.contains(activeTrigger)) {
        activeTrigger.focus();
      }
      activeTrigger = null;
    }

    function openDrawer(name, trigger) {
      closeAll({ restoreFocus: false });
      var drawer = root.querySelector('[data-mc-drawer="' + name + '"]');
      if (!drawer) return;

      activeTrigger = trigger || null;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'true');
      syncPageLock();

      var focusTarget;
      if (name === 'search') {
        focusTarget = drawer.querySelector('input[type="search"]');
      }
      if (!focusTarget) {
        focusTarget = drawer.querySelector('[data-mc-close], input, select, textarea, a[href], button:not([disabled]), summary');
      }
      if (focusTarget) {
        window.setTimeout(function () { focusTarget.focus(); }, 80);
      }
    }

    openers.forEach(function (button) {
      button.addEventListener('click', function () {
        openDrawer(button.getAttribute('data-mc-open'), button);
      });
    });

    root.querySelectorAll('[data-mc-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        closeAll({ restoreFocus: true });
      });
    });

    if (overlay) {
      overlay.addEventListener('click', function () {
        closeAll({ restoreFocus: true });
      });
    }

    document.addEventListener('keydown', function (event) {
      var openDrawerElement = getOpenDrawer();
      if (!openDrawerElement) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeAll({ restoreFocus: true });
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = getFocusable(openDrawerElement);
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var current = document.activeElement;

      if (!openDrawerElement.contains(current)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
        return;
      }

      if (event.shiftKey && current === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && current === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-mc-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
